import { faDashboard, faDollarCircle, faUser, faChartLineUp, faUsers } from '@fortawesome/pro-regular-svg-icons';

export const Categories = {
    DASHBOARD: 'Dashboard',
    CLIENTS_AND_PETS: 'Clients & Pets',
    SALES: 'Sales',
    BOOKINGS: 'Bookings',
    STAFF: 'Staff'
};

const getCategoryVisibility = (key: string): boolean => {
    switch (key) {
        case 'staff':
            return false;
        case 'dashboard':
        case 'bookings':
        case 'clients-and-pets':
        case 'sales':
            return true;
        default:
            return true;
    }
};

export const categoryDataBase = [
    {
        category: Categories.DASHBOARD,
        data: [
            {
                icon: faDashboard,
                title: Categories.DASHBOARD,
                key: 'dashboard'
            }
        ]
    },
    {
        category: Categories.BOOKINGS,
        data: [
            {
                icon: faChartLineUp,
                title: Categories.BOOKINGS,
                key: 'bookings'
            }
        ]
    },
    {
        category: Categories.SALES,
        data: [
            {
                icon: faDollarCircle,
                title: Categories.SALES,
                key: 'sales'
            }
        ]
    },
    {
        category: Categories.CLIENTS_AND_PETS,
        data: [
            {
                icon: faUser,
                title: Categories.CLIENTS_AND_PETS,
                key: 'clients-and-pets'
            }
        ]
    },
    {
        category: Categories.STAFF,
        data: [
            {
                icon: faUsers,
                title: Categories.STAFF,
                key: 'staff'
            }
        ]
    }
];

export const getCategoryData = (marketplaceId?: number) => {
    return categoryDataBase.map(categoryGroup => ({
        ...categoryGroup,
        data: categoryGroup.data.map(item => ({
            ...item,
            visible: getCategoryVisibility(item.key)
        }))
    }));
};

export const getCategoryKey = (categoryName: string) => {
    const category = categoryDataBase.find(cat => cat.category === categoryName);

    if (category && category.data.length > 0) {
        return category.data[0].key;
    }

    return 'insights';
};
